import login from "./login";
import common from "./common";
import survery from "./survey";
import takeout from "./takeout";
import store from "./store";
import application from "./application";
import housekeepser from "./housekeepser";
import pagemanage from "./pagemanage";
import group from "./group";
import setting from "./setting";
import backBilling from "./backBilling";
import channel from "./channel";
import order from "./order";

import ordercenter from "./ordercenter";
import finance from "./finance";
import user from "./user";
import shop from "./shop";

import activity from "./activity";
import levelOrPoint from "./levelOrPoint";
import workWx from "./workWx";
import evaluateRecovery from './evaluateRecovery'

export default {
  common,
  login, //登录
  // coupons, //核销验券
  takeout, //外卖
  store, //店铺相关
  application, //应用管理
  housekeepser, //家政员
  survery, //核销验券
  takeout, //外卖
  store, //店铺相关
  pagemanage, //页面管理
  group, //团购
  backBilling, //后台开单
  channel,

  ordercenter,
  shop,
  setting, //设置
  order, //家政订单
  finance, //交易记录
  user, //用户
  activity, //活动
  levelOrPoint, //会员积分与等级
  workWx, //企业微信
  evaluateRecovery //估价回收
}
